/** Fiscal filter predicate + option constants for payment/receipt list UIs. */

export type FiscalFilter = 'all' | 'fiscalized' | 'nonFiscalized';

export function matchesFiscalFilter(fiscalStatus: string, filter: FiscalFilter): boolean {
  if (filter === 'all') return true;
  if (filter === 'fiscalized') return fiscalStatus === 'issued';
  return fiscalStatus === 'not_required';
}

export const FISCAL_FILTER_OPTIONS: FiscalFilter[] = ['all', 'fiscalized', 'nonFiscalized'];
